const t = new Date()
const currentYear = t.getFullYear()
const currentMonth = t.getMonth()
const currentDay = t.getDate()

function setStoreHours() {
  const locationList = document.querySelectorAll('.locations-list-item')

  if (locationList.length > 0) {
    for (const location of locationList) {
      let textContainer = location.querySelector('.is-location-open') // changed from ID
      let openCloseTimeContainer = location.querySelector(
        '.location-open-close-time'
      ) // changed from ID
      const hoursContainer = location.querySelector('.location-hours') // changed from ID
      if (hoursContainer === null) {
        textContainer.innerText = 'No hours shown';
        continue;
      }
      const hours = JSON.parse(hoursContainer.dataset.hours)
      const closingTime = formatTime(hours.close) // formatTime() returns time as array ["HH", "MM"]
      const openTime = formatTime(hours.open)
      let openTime2 = null
      let closeTime2 = null
      
      //Check if closedAllDay bool is present. Set text and break/continue loop.
      if (hours.closedAllDay) {
        textContainer.innerText = 'Closed All Day'
        continue
      }

      if (hours.open2 != null && hours.open2.length > 0) {
        openTime2 = formatTime(hours.open2)
      }
      if (hours.close2 != null && hours.close2.length > 0) {
        closeTime2 = formatTime(hours.close2)
      }

      //create date objects for times. It makes it easy to compare.
      const closeDateTime = convertToDateObj(closingTime, isClosingNextDay(hours.close))
      const openDateTime = convertToDateObj(openTime)
      const openCloseDateTimes = { openDateTime, closeDateTime }
      const hoursOne = { open: hours.open, close: hours.close }
      const hoursTwo = { open: hours.open2, close: hours.close2 }
      
      if (closeTime2 != null && t >= closeDateTime) {
        const closingDateTime2 = convertToDateObj(closeTime2, isClosingNextDay(hours.close2))
        const openDateTime2 = convertToDateObj(openTime2)
        const openCloseDateTimes2 = { openDateTime: openDateTime2, closeDateTime: closingDateTime2 }

        setLocationHourText(openCloseDateTimes2, hoursTwo, textContainer, openCloseTimeContainer)
      } else {

        setLocationHourText(openCloseDateTimes, hoursOne, textContainer, openCloseTimeContainer)
      }
    }
  }
}

function setLocationHourText(openCloseDateTimeObject, hours, openCloseTextContainer, timeContainer) {
  const { openDateTime, closeDateTime } = openCloseDateTimeObject

  if (t <= openDateTime) {
    openCloseTextContainer.innerText = 'Closed Now - Opens at'
    timeContainer.innerText = `${hours.open}`
  }
  if (t >= openDateTime && t < closeDateTime) {
    openCloseTextContainer.innerText = 'Open Now - Closes at'
    timeContainer.innerText = `${hours.close}`
  }
  if (t >= closeDateTime) {
    openCloseTextContainer.innerText = 'Closed Now'
  }
}

function formatTime(timeString) {
  let timeAsArray = timeString.substring(0, 5).trim().split(':')

  if (timeString.includes('PM')) {
    let hourInt = parseInt(timeAsArray[0])
    if (hourInt < 12) {
      timeAsArray[0] = (hourInt + 12).toString() //setup hours to be in 24hrs
    }
    return timeAsArray
  } else {
    return timeAsArray // format time to be to be [HH, MM] vs "HH:MM PM"
  }
}

function convertToDateObj(timeArray, isNextDay = false) {
  return new Date(
    currentYear,
    currentMonth,
    isNextDay ? currentDay + 1 : currentDay,
    timeArray[0], // targeting hours
    timeArray[1] // targeting minutes
  )
}

function isClosingNextDay(closeTimeString) {
  if (closeTimeString.includes('AM')) {
    return true
  }
  return false
}

function init() {
  setStoreHours()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/locationsHours.js